import Api from '../../common/api';
import { multiPartUpload } from '@/utils';

const api = Api.getApi();

export async function getProductList({ params }) {
  const response = await api.request('get', '/products', { params: { ...params } });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestProductDetail(id) {
  const response = await api.request('get', `/products/${id}`);
  const { data } = response;
  return data;
}

export function requestDeleteProduct(id) {
  return api.request('delete', `/products/${id}`);
}

export async function requestCreateProduct(data) {
  return api.request('post', '/products', data);
}

export async function requestCreateProductSku(productId, data) {
  return await api.request('post', `/products/${productId}/skus`, data);
}

export function requestUpdateProduct({ payload }) {
  const { id, ...rest } = payload;
  return api.request('put', `/products/${id}`, rest);
}

export function createSku(skuList) {
  const sku = skuList.map(({ id, ...rest }) => requestCreateProductSku(id, rest));
  return Promise.all(sku);
}

export function requestDeleteSku({ payload }) {
  const { productId, id } = payload;
  return api.request('delete', `/products/${productId}/skus/${id}`);
}

export function requestUpdateSku({ payload }) {
  const { productId, id, ...rest } = payload;
  return api.request('put', `/products/${productId}/skus/${id}`, rest);
}

export async function requestSkuFiles(productId, productSkuId) {
  const response = await api.request('get', `/products/${productId}/skus/${productSkuId}/files`, {
    page: 1,
    limit: 1000,
  });
  const { data, metadata } = response;
  return { data, metadata };
}

export function uploadVariantFile({ productId, skuId, file }) {
  return api.request('post', `/products/${productId}/skus/${skuId}/files`, file, multiPartUpload);
}

export function requestGetProductTypes() {
  return api.request('get', `/product_types`);
}

export function requestGetProductSkuFileSubTypes() {
  return api.request('get', `/products/skus/file_sub_types`);
}

export function deleteVariantFile({ productId, skuId, fileId }) {
  return api.request('delete', `/products/${productId}/skus/${skuId}/files/${fileId}`);
}

export async function updateVariantFile({ productId, skuId, fileId, body }) {
  const response = await api.request(
    'post',
    `/products/${productId}/skus/${skuId}/files/${fileId}`,
    body,
    multiPartUpload,
  );
  return response;
}

export function uploadFiles(fileList) {
  //! TODO: organize data to upload
  const files = fileList.map((file) => uploadVariantFile(file));
  return Promise.all(files);
}

export async function requestIntegrationList({ params }) {
  const response = await api.request('get', '/integrations', { params: { ...params } });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestCreateIdentifiers(productId, productSkuId, data) {
  const response = await api.request(
    'post',
    `/products/${productId}/skus/${productSkuId}/identifiers`,
    data,
  );
  return response;
}

export async function requestIdentifiers(productId, productSkuId) {
  const response = await api.request(
    'get',
    `/products/${productId}/skus/${productSkuId}/identifiers`,
  );
  return response ? response.data : null;
}

export async function requestPutIdentifier(productId, productSkuId, productSkuIdentifierId, data) {
  return await api.request(
    'put',
    `/products/${productId}/skus/${productSkuId}/identifiers/${productSkuIdentifierId}`,
    data,
  );
}

export async function requestDeleteIdentifier(productId, productSkuId, productSkuIdentifierId) {
  return await api.request(
    'delete',
    `/products/${productId}/skus/${productSkuId}/identifiers/${productSkuIdentifierId}`,
  );
}

export async function requestBusinesses({ params }) {
  const response = await api.request('get', '/businesses', { params: { ...params } });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestGetProductPackType() {
  const response = await Api.getApi().request('get', '/products/skus/identifiers/pack_types');
  const { data, metadata } = response;
  return { data, metadata };
}
